export const generateSampleCode = (modelConfig, selectedModel, bearerToken) => {
  const model = modelConfig[selectedModel];
  const apiUrl = model?.apiUrl?.milford || model?.apiUrl?.warren || "";
  const modelName = selectedModel;
  const modelType = model?.type || "TGI";
  const tokenValue = bearerToken || "BEARER TOKEN HERE";

  const tgiCode = `import requests

# Static Bearer Token and ASMS Header
BEARER_TOKEN = "${tokenValue}"
ASMS_HEADER = "APPLICATION ASMS HERE"

# Model endpoint
MODEL_URL = "${apiUrl}/v1/chat/completions"

# Function to call the model
def generate(messages):
    headers = {
        'Content-Type': 'application/json',
        'Authorization': f'Bearer {BEARER_TOKEN}',
        'ASMS': ASMS_HEADER
    }

    payload = {
        "messages": messages,
        "stream": False,
        "model": "${modelName}",
        "max_tokens": 1000,
        "temperature": 0.1,
        "top_p": 0.9,
        "seed": 0,
        "n": 1
    }

    response = requests.post(MODEL_URL, json=payload, headers=headers)
    response.raise_for_status()
    result = response.json()

    return result["choices"][0]["message"]["content"]

# Example usage
if __name__ == "__main__":
    messages = [
        {"role": "system", "content": "You are an AI assistant..."},
        {"role": "user", "content": "Do something useful!"}
    ]

    output = generate(messages)
    print(output)`;

  const teiCode = `import requests

# Static Bearer Token and ASMS Header
BEARER_TOKEN = "${tokenValue}"
ASMS_HEADER = "APPLICATION ASMS HERE"

# Model endpoint
MODEL_URL = "${apiUrl}/embed"

# Function to get embeddings
def get_embeddings(texts):
    headers = {
        'Content-Type': 'application/json',
        'Authorization': f'Bearer {BEARER_TOKEN}',
        'ASMS': ASMS_HEADER
    }

    payload = {
        "inputs": texts
    }

    response = requests.post(MODEL_URL, json=payload, headers=headers)
    response.raise_for_status()
    result = response.json()

    return result

# Example usage
if __name__ == "__main__":
    texts = [
        "Hello world",
        "How are you doing today?",
        "This is a sample text for embedding"
    ]

    embeddings = get_embeddings(texts)
    print(f"Generated {len(embeddings)} embeddings")
    print(f"First embedding dimension: {len(embeddings[0])}")
    print(f"First few values: {embeddings[0][:5]}")`;

  return modelType === "TEI" ? teiCode : tgiCode;
};
